module.exports = __webpack_public_path__ + "media/images/category_icons/games-8e4e20b67bc452076729e72dab7c7379.svg";